import { useState } from 'react';

type ProductScreenshotsProps = {
  productName: string;
  sources: string[];
};

const ProductScreenshots = ({ productName, sources }: ProductScreenshotsProps) => {
  const [broken, setBroken] = useState<Record<number, boolean>>({});

  if (!sources.length) return null;

  return (
    <div className="w-full min-w-0">
      <h2 className="text-lg font-semibold text-slate-900 mb-4">Screenshots</h2>
      <div className="flex gap-4 overflow-x-auto pb-2 snap-x snap-mandatory -mx-1 px-1">
        {sources.map((src, i) => {
          const isBroken = broken[i];
          return (
            <figure
              key={`${src}-${i}`}
              className="shrink-0 snap-center w-[min(280px,85vw)] sm:w-[min(320px,40vw)]"
            >
              {isBroken ? (
                <div className="aspect-[9/19.5] rounded-2xl bg-slate-100 border border-dashed border-slate-300 flex items-center justify-center text-slate-400 text-sm text-center px-4">
                  Add image: {src.split('/').pop()}
                </div>
              ) : (
                <img
                  src={src}
                  alt={`${productName} screenshot ${i + 1}`}
                  className="w-full h-auto rounded-2xl border border-slate-200 shadow-card bg-slate-50 object-cover"
                  loading="lazy"
                  decoding="async"
                  onError={() => setBroken((b) => ({ ...b, [i]: true }))}
                />
              )}
            </figure>
          );
        })}
      </div>
    </div>
  );
};

export default ProductScreenshots;
